import { render } from "./pnc_treatment.vue?vue&type=template&id=3474d8de&scoped=true"
import script from "./pnc_treatment.vue?vue&type=script&lang=js"
export * from "./pnc_treatment.vue?vue&type=script&lang=js"

import "./pnc_treatment.vue?vue&type=style&index=0&id=3474d8de&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3474d8de"]])

export default __exports__